





import { Component, Prop, Model, Vue } from 'vue-property-decorator';
import BaseComponent from './BaseComponent.vue';

@Component
export default class AccordionList extends BaseComponent {
  @Prop({ default: true }) singleOpen!: boolean;
  @Prop({ default: true }) blocking!: boolean;


  acoddionItems: any[] = [];
  accodionIds: string[] = [];
  completed: boolean = false;
  created() {
    if (this.blocking) this.lockForward();
  }

  mounted() {
    this.$children.map(child => {
      if ((child.$options as any)._componentTag == 'AccordionItem') {
        child.$on('toggle', this.handleAccordionToggle);
        (child as any).showCompletion = this.blocking;
        this.acoddionItems[(child as any)._uid] = child;
        this.accodionIds.push((child.$el as any).dataset.id);
      }
    });
  }
  handleAccordionToggle(e: any) {
    if (this.singleOpen)
      this.acoddionItems.map(item => {
        if ((item as any)._uid != e.id) item.close();
      });
    this.handleCompletion();
  }
  handleCompletion() {
    if (this.acoddionItems.every(child => child.completed) && !this.completed) {
      this.completed = true;
      if (this.blocking) this.unlock();
    }
  }
  private handleArrow(direction: number) {
    if (document.activeElement && document.activeElement.parentElement) {
      let currentId = document.activeElement.id;
      let currentIndex = this.accodionIds.indexOf(currentId);
      if (currentIndex > -1) 
        this.focusOnNextElement(direction, currentIndex);
      
    }
  }

  private focusOnNextElement(direction: number, currentIndex: number) {
    let nextIndex = this.getNextIndex(
      direction,
      currentIndex,
      this.accodionIds.length
    );

    let nextElement = this.getAccordionButtonsElementsByIndex(nextIndex);
    if (nextElement) nextElement.focus();
  }

  private getNextIndex(
    direction: number,
    currentIndex: number,
    totalItens: number
  ): number {
    if (currentIndex === totalItens - 1 && direction > 0) 
      currentIndex = 0;
    else 
    if (currentIndex == 0 && direction < 0) 
      currentIndex = totalItens - 1;
    else 
      currentIndex += direction;
      
    
    return currentIndex;
  }

  public getAccordionButtonsElementsByIndex(index: number): HTMLElement | null {
    return document.getElementById(`${this.accodionIds[index]}`);
  }
}
